// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bundle-title[data-v-442b081b]{display:flex;align-items:center}.bundle-title h2[data-v-442b081b]{margin:0 10px 0 0}.bundle-title span[data-v-442b081b]{background-color:var(--darker);color:var(--default);padding:5px 10px;border-radius:15px}", ""]);
// Exports
module.exports = exports;
